import React from 'react';
import { connect } from 'react-redux';
import { choices } from '../../../../choices';
import makeForm from '../makeForm';
import ContinueButton from '../ContinueButton';
import Form from '../../Common/Form';
import FormGroup from '../../Common/FormGroup';
import Input from '../../Common/Input';
import RadioGroup from '../../Common/RadioGroup';
import SelectCar from '../../Common/SelectCar.js'
import SelectBrandCar from '../../Common/SelectBrandCar.js';
import GoBackButton from '../../Common/GoBackButton';
import { url } from '../../../../config';
import s from '../../Common/GoBackButton.scss';
import sc from '../ChatsForm.scss';

const CarDataForm = ({
    values,
    handleChange,
    errors,
    options,
    onSubmit,
    carBrandChange,
    carModelChange,
    carVersionChange,
    carHandleChange,
    apptype
}) => {
    const fixGNC = (values.gnc === false) ? "no" : values.gnc;
    const fixIsFinanced = (values.is_financed === false) ? "no" : values.is_financed;
    let carData;
    if(apptype === 'cp'){
        carData = (values.year && values.brand && values.model && values.version && values.purpose && fixGNC) ? false : true;
    }else {
        carData = (values.patent && values.year && values.brand && values.model && values.version && values.zone && values.purpose && fixGNC && fixIsFinanced) ? false : true;
    }
    return(
        <div>
            <div className={sc.formContainer}>
                <div className={s.goBack}><GoBackButton children={'Volver'} link={url('cotitulares', apptype)}/></div>
                <h3 className="chat-title">Datos del vehículo</h3>
                <Form onSubmit={onSubmit}>
                    {(apptype !== 'cp') && <FormGroup label='Patente' tooltipDesc={'patente'} tooltip={true} >
                        <Input
                            placeholder='AAA123 o AA123CC'
                            name='patent'
                            type='text'
                            onChange={carHandleChange}
                            value={values.patent}
                            errors={errors.patent}
                        />
                    </FormGroup>}
                    <FormGroup label='Año'>
                        <SelectCar
                            options={options.year}
                            name="year"
                            onChange={carHandleChange}
                            errors={errors.year}
                            value={values.year}
                        />
                    </FormGroup>
                    <FormGroup label='Marca'>
                        <SelectBrandCar
                            options={options.brand}
                            name="brand"
                            onChange={carBrandChange}
                            errors={errors.brand}
                            value={values.brand}
                        />
                    </FormGroup>
                    <FormGroup label='Modelo'>
                        <SelectCar
                            options={options.model}
                            name="model"
                            onChange={carModelChange}
                            errors={errors.model}
                            value={values.model}
                        />
                    </FormGroup>
                    <FormGroup label='Versión'>
                        <SelectCar
                            options={options.version}
                            name="version"
                            onChange={carVersionChange}
                            errors={errors.version}
                            value={values.version}
                        />
                    </FormGroup>
                    {(apptype !== 'cp') && <RadioGroup
                    label="¿En dónde está radicado el vehículo?"
                    name="zone"
                    onChange={handleChange}
                    selected={values.zone}
                    errors={errors.zone}
                    >
                    {choices.zonesCar.map(({ text, value }) => [text, value])}
                    </RadioGroup>}
                    <RadioGroup
                        label="¿Qué tipo de uso le das al vehículo?"
                        onChange={handleChange}
                        name="purpose"
                        selected={values.purpose}
                        errors={errors.purpose}
                    >
                    {choices.purposes.map(({ text, value }) => [text, value])}
                    </RadioGroup>
                    <RadioGroup
                        label="¿Tiene GNC?"
                        onChange={handleChange}
                        name="gnc"
                        selected={values.gnc}
                        errors={errors.gnc}
                        flexButton={true}
                    >
                        {[
                            ['Si', true],
                            ['No', false]
                        ]}
                    </RadioGroup>
                    {(apptype !== 'cp') && <RadioGroup
                        label="¿Estás pagando cuotas por el vehículo?"
                        onChange={handleChange}
                        name="is_financed"
                        selected={values.is_financed}
                        errors={errors.is_financed}
                        flexButton={true}
                        tooltipDesc={'Por ejemplo pago de cuotas en un Plan de Ahorro o Crédito Prendario'}
                    >
                        {[
                            ['Si', true],
                            ['No', false]
                        ]}
                    </RadioGroup>
                    }
                    <div style={{paddingTop: '25px'}}>
                        <ContinueButton autoFocus={false} sticky={true} disabled={carData}/>
                    </div>
                </Form>
            </div>
        </div>
    )
}
const mapStateToProps = ({ user }) => ({ is_staff: !!user.is_staff });

export default connect(mapStateToProps)(makeForm(CarDataForm));
